module.exports = __webpack_public_path__ + "fonts/IRANSansWeb.ba77cad.ttf";